import { Component, OnInit } from '@angular/core';
import { HelpersService } from '../../../../services/helpers.service';
import { PartnerService } from '../../../../services/partner.service';
import { MessageService } from 'primeng/api';
import { TranslateService } from '@ngx-translate/core';

@Component({
  selector: 'app-checklist-items',
  templateUrl: './checklist-items.component.html',
  styleUrls: ['./checklist-items.component.scss'],
  providers: [MessageService],
})
export class ChecklistItemsComponent implements OnInit {
  public partnerId: string = '';
  public checklistConfigs: any = [];
  public chkListBox: any = [];
  public checklistConfig: any = {};
  public selectedChecklistConfig: any = {};

  public checklistGroups: any = [];
  public grpListBox: any = [];
  public grpDropDown: any = [];
  public checklistGroup: any = {};
  public selectedChecklistGroup: any = {};

  public saving: boolean = false;

  constructor(
    private helpersService: HelpersService,
    private partnerService: PartnerService,
    public messageService: MessageService,
    private translate: TranslateService,
  ) {
    this.partnerId = this.helpersService.getPartnerId();
  }

  ngOnInit() {
    this.getChecklistGroups();
    this.getChecklistConfig();
  }

  getChecklistGroups() {
    this.checklistGroups = [];
    this.partnerService
      .getChecklistGroups(this.partnerId)
      .subscribe((items) => {
        this.checklistGroups = items;
        this.grpListBox = items.map((item) => {
          return { label: item.Description, value: item.ID };
        });
        this.grpDropDown = [
          ...[{ label: '', value: 0 }],
          ...items.map((item) => {
            return { label: item.Description, value: item.ID };
          }),
        ];
      });
  }

  getChecklistConfig() {
    this.checklistConfigs = [];
    this.partnerService
      .getChecklistConfigAll(this.partnerId)
      .subscribe((items) => {
        this.checklistConfigs = items;
        this.chkListBox = items.map((item) => {
          return { label: item.Description, value: item.ID };
        });
      });
  }

  getChecklistConfigItem() {
    this.checklistGroup = {};
    this.checklistConfig = {};
    this.selectedChecklistGroup = {};
    if (this.selectedChecklistConfig > 0) {
      this.checklistConfig = this.checklistConfigs.filter((item) => {
        return item.ID === this.selectedChecklistConfig;
      })[0];
    }
  }

  getChecklistGroup() {
    this.checklistGroup = {};
    this.checklistConfig = {};
    this.selectedChecklistConfig = {};
    if (this.selectedChecklistGroup > 0) {
      this.checklistGroup = this.checklistGroups.filter((item) => {
        return item.ID === this.selectedChecklistGroup;
      })[0];
    }
  }

  addNewGroup() {
    this.selectedChecklistGroup = {};
    this.selectedChecklistConfig = {};
    this.checklistConfig = {};
    this.checklistGroup = {
      ID: 0,
      Description: '',
      PartnerID: this.partnerId,
    };
  }

  addNewItem() {
    this.selectedChecklistGroup = {};
    this.selectedChecklistConfig = {};
    this.checklistGroup = {};
    this.checklistConfig = {
      ID: 0,
      Description: '',
      GroupID: 0,
      IsActive: false,
      PartnerID: this.partnerId,
    };
  }

  saveGroup() {
    this.saving = true;
    this.partnerService
      .saveChecklistGroup(this.checklistGroup)
      .subscribe((group) => {
        this.saving = false;
        this.checklistGroup = group;
        this.messageService.add({
          life: 5000,
          summary: this.translate.instant(
            'bikeshop.checklist_items.checklist_group_updated',
          ),
          detail: this.translate.instant(
            'bikeshop.checklist_items.checklist_group_updated_message',
            { groupName: this.checklistConfig.Description },
          ),
        });
        this.getChecklistGroups();
      });
  }

  saveItem() {
    this.saving = true;
    this.partnerService
      .saveChecklistConfigItem(this.checklistConfig)
      .subscribe((item) => {
        this.saving = false;
        this.checklistConfig = item;
        this.messageService.add({
          life: 5000,
          summary: this.translate.instant(
            'bikeshop.checklist_items.checklist_item_updated',
          ),
          detail: this.translate.instant(
            'bikeshop.checklist_items.checklist_item_updated_message',
            { groupName: this.checklistConfig.Description },
          ),
        });
        this.getChecklistConfig();
      });
  }
}
